import { render, staticRenderFns } from "./Contacts.vue?vue&type=template&id=5b378aa0&scoped=true"
var script = {}
import style0 from "./Contacts.vue?vue&type=style&index=0&id=5b378aa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b378aa0",
  null
  
)

export default component.exports